// component/carousel.jsx
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const LoginCarousel = () => {
  const carouselTexts = [
    'Facilitando escalas, otimizando tempos',
    'Gerencie com eficiência e praticidade',
    'Sua solução para um workflow perfeito',
  ];

  return (
    <Carousel
      autoPlay
      infiniteLoop
      swipeScrollTolerance={3}
      showThumbs={false}
      showStatus={false}
      useKeyboardArrows
      interval={3000}
      transitionTime={500}
      showArrows
      showIndicators
      className="h-full w-full"
    >
      {carouselTexts.map((text, index) => (
        <div
          key={`content-${index}`}
          className="flex h-screen items-center justify-center px-10 text-center text-white"
        >
          <h2 className="text-2xl md:text-4xl leading-snug">{text}</h2>
        </div>
      ))}
    </Carousel>
  );
};

export default LoginCarousel;
